class SwiperComment extends HTMLElement {
    constructor() {
        super();
      
    }   
    connectedCallback() {
        this.initSlider();
    }

    initSlider() {
        this.swiper = new Swiper(this.querySelector('.swiper-comment'), {
            slidesPerView: 1.4,
            spaceBetween: 6,
            centeredSlides: true,
            loop: true,
            pagination: {
                el: '.swiper-comment-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-comment-button-next',
                prevEl: '.swiper-comment-button-prev',
            },
            breakpoints: {
                700: {
                    slidesPerView: 'auto',
                    spaceBetween: 18,
                }
            }
        });
    }
}

customElements.define('swiper-comment', SwiperComment);